var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.params.data)?_c('b-btn',{staticClass:"btn-sm",attrs:{"variant":"primary","to":{ name: _vm.editRoute.name, params: { id: _vm.params.data.id } },"title":"Edit"}},[_c('i',{staticClass:"fas fa-fw fa-edit"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }